var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment-icon"},[(_vm.icon)?_c('img',{attrs:{"src":_vm.icon.url,"alt":_vm.icon.alt}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }